import { Dialog } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

function CustomDialog({
  children,
  open = false,
  onClose = () => {},
  fullScreen = false,
  maxWidth = "sm",
  fullWidth = true,
  noDialog = false,
  showCross = false,
}) {
  if (noDialog) {
    return <div className={`flex flex-col w-full h-full`}>{children}</div>;
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={{ zIndex: 10000, margin: "10px" }}
      PaperProps={{
        style: {
          borderRadius: "6px", // Set your desired border radius here
          padding: "16px",
        },
      }}
    >
      {showCross && (
        <span
          className="absolute top-[1px] right-[1px] cursor-pointe z-[11000] bg-white border border-gray-600 rounded-full w-[20px] h-[20px] flex items-center justify-center"
          onClick={onClose}
        >
          <CloseIcon />
        </span>
      )}

      {children}
    </Dialog>
  );
}

export default CustomDialog;
